import client from "client/client";
import {RunSqlRequest} from "~/client/resources/runSqlRequest";

export default class AdministrationRepository {

    private rootUri = "/api/administration";
    
    runSql(request: RunSqlRequest){
        return client.post(`api/administration/sql`, request);
    }
}
